<template>
  <div class="page-wrapper">
    <div class="page-inner bg-brand-gradient">
      <div class="page-content-wrapper bg-transparent m-0">
        <start-header />

        <start-body />

        <start-footer />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import StartBody from '@/components/startLayout/Body';
import StartFooter from '@/components/startLayout/Footer';
import StartHeader from '@/components/startLayout/Header';

// @vuese
// Layout aplikacji dla niezalogowanego użytkownika
// @group Layouts
export default {
  components: { StartFooter, StartHeader, StartBody },

  computed: mapState({ appTitle: state => state.system.appTitle }),

  created() {
    document.title = this.appTitle;
  }
};
</script>
